const entries = Object.entries;
const keys = Object.keys;
const values = Object.values;
const filterByKey = (o, predicate) => {
  return Object.fromEntries(entries(o).filter(([k]) => predicate(k)));
};
const filterByValue = (o, predicate) => {
  return Object.fromEntries(entries(o).filter(([, v]) => predicate(v)));
};
const isShallowEqual = (o1, o2) => {
  const keySet = /* @__PURE__ */ new Set([...keys(o1), ...keys(o2)]);
  return Array.from(keySet).every((key) => o1[key] === o2[key]);
};

export { entries, filterByKey, filterByValue, isShallowEqual, keys, values };
//# sourceMappingURL=object.mjs.map
